import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import Logout from "pages/Auth/Logout";
import EmployeeDashboard from "area/employer/EmployeeDashboard";
import Dashboard from "area/employer/Dashboard";
import Messages from "area/employer/Messages";
import TimeSheets from "area/employer/TimeSheets";
import HWStatement from "area/employer/HWStatement";
import Uploads from "area/employer/Uploads";
import Reports from "area/employer/Reports";
import Accounting from "area/employer/Accounting";
import ExcessAllocation from "area/employer/ExcessAllocation";
import Hourbank from "area/employer/Hourbank";
import Files from "area/employer/Files";
import HoursUpload from "area/employer/HoursUpload";
import Communication from "area/employer/Communication";

import Feedback from "area/Feedback";
import Settings from "area/employer/Settings";
import Census from "area/employer/Census";
import GsgCensus from "area/employer/GsgCensus";
import SpaceCoLab from "area/employer/SpaceCoLab";
import BrdTimeline from "area/employer/BrdTimeline";
import LogiqMindManager from "components/Pages/LogiqMindManager";
import Contracts from "area/employer/Contracts";
import Layout from "./Layout"

export default function ERUIRoutes({ portal }) {
  const { modalIsOpen,setModalIsOpen, companyId, setCompany,userInfo } = useContext(PrivateRoutesContext);

  useEffect(() => {
    let selectedCompany = localStorage.getItem(`selectedCompanyId`);
    console.log(`selected company ${selectedCompany}`)
    if (selectedCompany !== undefined){
      if (selectedCompany != null && selectedCompany != "") {
        setCompany(selectedCompany)
      }
      else{
        console.log("Prompting for company from ERUIRoutes")
        setModalIsOpen(true)
      }  
    }
    else{
      console.log("selectedCompany undefined Prompting for company from ERUIRoutes")
      setModalIsOpen(true)
    }

    document.title = "AXIM FringeSecure | Employer";
  }, []);

    let { path, url } = useRouteMatch();
    let censusComponent = Census;
    if(userInfo?.companyDetails?.groupType=='GSG'){
      censusComponent = GsgCensus;
    }
    return (
      <Layout >
        <Switch>
          <Route exact path={`${path}/`}>
            <Redirect to={`${path}/dashboard`} />
          </Route>
          <Route exact path={`${path}/dashboard`} component={Dashboard} />
          <Route exact path={`${path}/logout`} component={Logout} />
          <Route exact path={`${path}/employee`} component={EmployeeDashboard} />
          <Route exact path={`${path}/messages`} component={Messages} />
          <Route exact path={`${path}/time-sheets`} component={TimeSheets} />
          <Route exact path={`${path}/hw-statement`} component={HWStatement} />
          <Route exact path={`${path}/uploads`} component={Uploads} />
          <Route exact path={`${path}/reports`} component={Reports} />
          <Route exact path={`${path}/accounting`} component={Accounting} />
          <Route exact path={`${path}/excess-allocation`} component={ExcessAllocation} />
          <Route exact path={`${path}/hourbank`} component={Hourbank} />
          <Route exact path={`${path}/feedback`} component={() => <Feedback portal={portal}/>} />
          <Route exact path={`${path}/files`} component={Files} />
          <Route exact path={`${path}/settings`} component={Settings} />
          <Route exact path={`${path}/hours-file`} component={HoursUpload} />
          <Route exact path={`${path}/communication`} component={Communication} />
          <Route exact path={`${path}/census`} component={censusComponent} />
          <Route exact path={`${path}/space-co-lab`} component={SpaceCoLab} />
          <Route exact path={`${path}/brd`} component={BrdTimeline} />
          <Route exact path={`${path}/logiqmind-reports`} component={LogiqMindManager} />
          <Route exact path={`${path}/contracts`} component={Contracts} />
        </Switch>
      </Layout>
    )
}